import { createFileRoute } from "@tanstack/react-router";
import Dashboard from "@/pages/Dashboard";
import SubscribedRoute from "@/components/shared/SubscribedRoute";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/dashboard/")({
  head: () => routeHead("/de/dashboard/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SubscribedRoute><Dashboard /></SubscribedRoute>
  );
}
